import ItemImageJson, { validateItemImageJson, validateItemImageJsonAdd } from "./ItemImageJson";
import { Validation, ValidationResult } from "./Validation";

/**
 * Beschreibung für einen Gegenstand, bestehend aus Text und Bildern.
 */
export default interface ItemDescriptionJson {
    ID: number | null;

    /**
     * Markdown formatierter Beschreibungstext.
     */
    text: string;

    /**
     * Bilder als Anhang. Maximal 5 Stück.
     */
    images: ItemImageJson[];
}



export function defaultItemDescriptionJson(): ItemDescriptionJson {
    return {
        ID: null,
        text: "",
        images: [],
    };
}

export function validateItemDescriptionJson(json: ItemDescriptionJson): ValidationResult<ItemDescriptionJson> {
    return new Validation(json)
        .validateInteger("ID", 0, null, true)
        .validateAllUsingFunction("images", validateItemImageJson, 0, false, 5)
        .finish();
}
export function validateItemDescriptionJsonAdd(json: ItemDescriptionJson): ValidationResult<ItemDescriptionJson> {
    return new Validation(json)
        .validateEquals("ID", null)
        .validateAllUsingFunction("images", validateItemImageJsonAdd, 0, false, 5)
        .finish();
}